import type { GetServerSideProps } from 'next';
import feature_gw_sale_2025 from '../../../public/images/feature_gw_sale_2025.png';
import { createFeatureNamePage } from '../../features/featurePages/featureNameTemplate';
import type { CommonFeatureSSRProps } from '../../server/features/commonFeatureServerSideProps';

export const getServerSideProps: GetServerSideProps<CommonFeatureSSRProps> =
  async (ctx) => {
    const { commonFeatureGetServerSideProps } = await import(
      '../../server/features/commonFeatureServerSideProps'
    );
    return commonFeatureGetServerSideProps(ctx);
  };

export default createFeatureNamePage({
  slug: 'gwsale_2025',
  featureName: 'GWセール',
  title: 'GWセールメニュー一覧',
  description: 'あの占い師も特別価格で試せる！期間限定のセールメニュー特集',
  ogImageUrl: 'https://raysee.jp/images/feature_gwsale_2025.png',
  heroImage: feature_gw_sale_2025,
});
